import { ButtonWithLoading } from "@/components/shared/buttons/ButtonWithLoading";
import { ErrorModal } from "@/components/shared/modal/error-modal";
import Modal from "@/components/shared/modal/modal";
import { PageTitle } from "@/components/shared/title/page-title";
import { recoverSnapshot } from "@/pages/configurations/snapshots/repositories/snapshots.repository";
import { Button, Grid, Paper, TextField } from "@material-ui/core";
// @flow
import * as React from "react";
import { useState } from "react";
import { CheckmarkIcon, toast } from "react-hot-toast";

type Props = {};
export const Snapshots = (props: Props) => {
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState("");
	const [days, setDays] = useState<number | string>(10);
	const [showConfirm, setShowConfirm] = useState(false);

	const onChange = (
		e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
	) => {
		setDays(e.target.value);
	};

	const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		setShowConfirm(true);
	};

	const onSubmitConfirm = async () => {
		setIsLoading(true);
		setShowConfirm(false);
		const resp = await recoverSnapshot(days);
		if (resp.ok) {
			toast("Success", {
				icon: <CheckmarkIcon />,
			});
		} else {
			setError(resp.message);
		}
		setIsLoading(false);
	};

	return (
		<>
			<PageTitle title="Recover Snapshot" />
			<Paper>
				<Grid
					container
					justifyContent={"center"}
					alignItems={"center"}
					style={{ minHeight: "30vh" }}
					spacing={3}
				>
					<Grid item container xs={12} justifyContent={"center"}>
						<h1>Recover Snapshot</h1>
					</Grid>
					<form onSubmit={onSubmit}>
						<Grid
							item
							container
							xs={12}
							justifyContent={"center"}
							alignItems={"center"}
							spacing={3}
						>
							<Grid item xs={12}>
								<TextField
									value={days}
									onChange={onChange}
									variant={"outlined"}
									label={"Days"}
									fullWidth
									type={"number"}
									inputProps={{ step: "1", style: { textAlign: "center" } }}
								/>
							</Grid>
							<Grid item xs={12}>
								<ButtonWithLoading
									type={"submit"}
									variant={"contained"}
									color={"primary"}
									isLoading={isLoading}
									fullWidth
								>
									SUBMIT
								</ButtonWithLoading>
							</Grid>
						</Grid>
					</form>
				</Grid>
			</Paper>
			<ErrorModal error={error} onHide={() => setError("")} />
			<Modal
				title={"Are you sure?"}
				open={showConfirm}
				handleClose={(shouldUpdate) => setShowConfirm(false)}
				maxWidth={"xs"}
			>
				<Modal.Content>You are going to lose all changes</Modal.Content>
				<Modal.Actions>
					<Grid container justifyContent={"space-between"}>
						<Grid item>
							<Button
								variant={"outlined"}
								onClick={() => setShowConfirm(false)}
							>
								Cancel
							</Button>
						</Grid>
						<Grid item>
							<Button
								variant={"contained"}
								color={"primary"}
								onClick={() => onSubmitConfirm()}
							>
								Confirm
							</Button>
						</Grid>
					</Grid>
				</Modal.Actions>
			</Modal>
		</>
	);
};
